export class CustomParamsMessageEventModel {
  CallId: string;
  DisplayEventLog: boolean;
}
